// extracted by mini-css-extract-plugin
module.exports = {"chliyqs":"chliyqs"};